import React from "react";
import PropTypes from "prop-types";
import { completeOAuth, extractSyncError } from "../../../utils/api/SyncApi";

export default class AzureConfigurationLink extends React.Component {
  componentDidMount() {
    const self = this;
    const query = this.props.location.query;

    const redirectWithError = (message) => {
      self.context.router.push({
        pathname: "/config/device/authentication/azure",
        state: { linkError: message },
      });
    };

    if (query.error) {
      redirectWithError(query.error_description || "Credentials linking was denied or cancelled.");
      return;
    }

    if (!query.code) {
      redirectWithError("Credentials linking was denied or cancelled.");
      return;
    }

    const storedState = localStorage.getItem("oauth_state_AZURE");
    localStorage.removeItem("oauth_state_AZURE");
    if (!storedState) {
      redirectWithError("Credential linking was not started from School Manager. Please link again from this page.");
      return;
    }
    if (!query.state || query.state !== storedState) {
      redirectWithError("Credential linking could not be verified. Please try again.");
      return;
    }
    completeOAuth(storedState, query.code)
      .then(() => self.context.router.push("/config/device/authentication/azure"))
      .catch((e) => redirectWithError(extractSyncError(e, "Failed to link Microsoft Entra ID credentials. Please try again.")));
  }

  render() {
    return <div />;
  }
}

AzureConfigurationLink.contextTypes = {
  router: PropTypes.object.isRequired,
};
